import { Directive, Input, OnChanges, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { PermissionLike } from 'src/app/common/enums/permissions';
import { PermissionService } from '../services/permission.service';

@Directive({
  selector: '[ifHasPermissionsOnWorkerProfile]',
  standalone: false
})
export class IfHasPermissionsOnWorkerProfileDirective implements OnChanges {
  private view = inject(ViewContainerRef);
  private template = inject<TemplateRef<any>>(TemplateRef);
  private permissionService = inject(PermissionService);

  @Input('ifHasPermissionsOnWorkerProfile') permissions: PermissionLike[];
  @Input('ifHasPermissionsOnWorkerProfileAuthServerUserId') authServerUserId: string;

  constructor() { }

  ngOnChanges(): void {
    if (this.permissionService.hasPermissionsOnWorkerProfile(this.authServerUserId, ...this.permissions)) {
      this.view.createEmbeddedView(this.template);
    } else {
      this.view.clear();
    }
  }
}
